import React, { useEffect } from "react";
import "../styles/About.css";
import profileImg from "../images/Profile.png";
import AboutImg from "../images/about4.jpg";
import bewingz from '../images/bewingz.svg';
import jurident from "../images/jurident.png"
import AOS from 'aos';
import 'aos/dist/aos.css';

const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, 
      easing: 'ease-in-out', 
      once: false,
    });
  }, []);
  

  return (
    <div className="flex flex-col justify-center items-center gap-4 pt-28 md:pt-16">

      <div data-aos="fade-up">
        <p className="text-2xl tracking-widest font-extrabold">BIOGRAPHY</p>
      </div>

      <div className="flex flex-col justify-center gap-10">
        <div className="" data-aos="flip-up">
          <img src={AboutImg} alt="Profile" className="w-screen h-56 object-cover"/>
        </div>
        <div className="flex flex-col items-center text-justify gap-4 mx-10 md:mx-16 lg:mx-32">
          <p className="text-ms font-light tracking-wide" data-aos="fade-up">
          <span className="font-normal">Hi, I am a skilled software 
          engineer</span> with a passion for problem-solving and technology. I hold a Bachelor's degree in Computer Science <span className="font-normal">(BSc)</span> from Vellore
            Institute of Technology (VIT) with a CGPA of 8.49 and a Master's
            degree in Computer Applications <span className="font-normal">(MCA)</span> with a CGPA of 7.96. With
            strong expertise in <span className="font-normal">Java, ReactJS, Node.js, MySQL, Android
            Development using Java, WordPress, and Tailwind CSS </span>for front-end
            design, I bring a well-rounded skill set to the table. I am
            proficient in using Git for version control and have extensive
            experience with VSCode as my primary development environment.{" "}
          </p>
          <p className="text-md font-light" data-aos="fade-up">
            I specialize in <span className="font-normal">data structures and algorithms</span>, where I apply a
            structured approach to solving complex problems efficiently. I’m a
            talented and time-managed individual with a knack for quickly
            adapting to new challenges and technologies. I thrive on working in
            dynamic environments and enjoy experimenting with innovative
            solutions to improve processes and outcomes. I’m constantly looking
            for opportunities to grow professionally and explore new areas of
            software development.
          </p>
        </div>
      </div>

      <div className="flex flex-row gap-2 p-2 items-center bg-white" data-aos="fade-up">
      <p className="text-black">Interned at: </p>
      <img src={bewingz} width={100}/>
      <img src={jurident} width={15}/><span className="text-[#CEA659] text-md font-semibold">Jurident</span>
      </div>
    </div>
  );
};

export default About;
